class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.addEventListener('click', this.handleComplementaryAddClick.bind(this));
    document.addEventListener('keydown', this.handleEscapeKeyPress.bind(this));
  }

  bindEvents() {
    const drawerBtn = document.querySelector("[data-cart-drawer]");

    if (drawerBtn) {
      drawerBtn.addEventListener('click', this.openCartDrawer.bind(this));
    }

    this.querySelectorAll('[data-close-drawer], [data-drawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );

    this.setupDialogEvents();
  }

  setupDialogEvents() {
    let lastFocusedElement = '';

    Array.from(this.querySelectorAll('.modal-dialog-button')).forEach((openBtn) => {
      openBtn.addEventListener('click', () => {
        const modalId = openBtn.dataset.modal;
        const dialog = this.querySelector(`cart-dialog#${modalId}`);

        if (dialog) {
          setTimeout(() => {
            dialog.classList.add('is-visible');

            setTimeout(() => {
              lastFocusedElement = openBtn;
              trapFocusElements(dialog);
            }, 600);
          }, 500);
        }
      });
    });

    Array.from(this.querySelectorAll('[data-dialog-close]')).forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const dialog = closeBtn.closest('cart-dialog');

        if (dialog) {
          dialog.classList.remove('is-visible');
        }

        trapFocusElements(document.querySelector('cart-drawer'));

        setTimeout(() => {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }

          lastFocusedElement = '';
        }, 400);
      });
    });
  }

  openCartDrawer(event) {
    if (event) {
      event.preventDefault();
    }

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        this.innerHTML = this.getSectionHTML(html, 'cart-drawer');

        this.classList.add('is-visible');
        document.querySelector('body').classList.add('overflow-hidden');

        this.querySelectorAll('[data-close-drawer], [data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );

        setTimeout(() => {
          if (event) {
            focusElement = event.target;
          }

          trapFocusElements(document.querySelector('cart-drawer'));
        }, 500);

        const cartBody = document.querySelector('#cart-drawer-body-content');
        const totalPrice = cartBody?.getAttribute('data-cart-price');

        if (typeof freeShippingBarProgress === 'function' && totalPrice) {
          freeShippingBarProgress(totalPrice);
        }

        this.setupDialogEvents();
      })
      .catch((e) => console.error(e));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        const sectionHTML = this.getSectionHTML(parsedState.sections[section.id], section.selector);

        document.querySelector(section.selector).innerHTML = sectionHTML;

        const parsedHTML = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
        const cartBody = parsedHTML.querySelector('#cart-drawer-body-content');
        const totalCount = cartBody?.getAttribute('data-cart-count');

        const priceElement = document.querySelector('[data-cart-price]');

        if (priceElement && typeof freeShippingBarProgress === 'function') {
          const totalPrice = parseInt(priceElement.dataset.cartPrice);
          freeShippingBarProgress(totalPrice);
        }

        const itemCountElement = document.querySelector('[data-item-count]');

        if (itemCountElement) {
          itemCountElement.classList.remove('hidden');

          if (totalCount == 0) {
            itemCountElement.classList.add('hidden');
          } else if (totalCount < 100) {
            itemCountElement.textContent = totalCount;
          } else {
            itemCountElement.textContent = '99+';
          }
        }

        trapFocusElements(document.querySelector('cart-drawer'));

        this.setupDialogEvents();

        this.querySelectorAll('[data-close-drawer], [data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );
      }
    });
  }
handleComplementaryAddClick(event) {
  const button = event.target.closest('[data-cart-complementary-add]');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId || button.disabled) return;

  const textElement = button.querySelector('[data-add-to-cart-text]');
  const spinner = button.querySelector('.loading--spinner');

  button.disabled = true;
  button.classList.add('loading');
  textElement?.classList.add('hidden');
  spinner?.classList.remove('hidden');

  const config = fetchConfig('javascript');

  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();

  formData.append('id', variantId);
  formData.append('quantity', '1');
  formData.append('sections', this.getSectionsToRender().map((section) => section.id));
  formData.append('sections_url', window.location.pathname);

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error(response.description || response.message);
        return;
      }

      this.renderContents(response);
      this.classList.add('is-visible');
      document.querySelector('body').classList.add('overflow-hidden');
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      button.disabled = false;
      button.classList.remove('loading');
      textElement?.classList.remove('hidden');
      spinner?.classList.add('hidden');
    });
}
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }

  getSectionHTML(html, selector = 'cart-drawer') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);

    return element ? element.innerHTML : '';
  }

  closeDrawer(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.classList.contains('is-visible')) {
      this.classList.remove('is-visible');
      document.querySelector('body').classList.remove('overflow-hidden');
    }

    if (focusElement) {
      focusElement.focus();
    }

    focusElement = '';
    removeTrapFocus();
  }

  handleEscapeKeyPress(event) {
    if (event.key === 'Escape') {
      this.closeDrawer(event);
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartShippingContent extends HTMLElement {
  constructor() {
    super();

    this.debounceTimer = null;
    this.abortController = null;

    this.brazilStates = {
      AC: 'Acre',
      AL: 'Alagoas',
      AP: 'Amapá',
      AM: 'Amazonas',
      BA: 'Bahia',
      CE: 'Ceará',
      DF: 'Distrito Federal',
      ES: 'Espírito Santo',
      GO: 'Goiás',
      MA: 'Maranhão',
      MT: 'Mato Grosso',
      MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais',
      PA: 'Pará',
      PB: 'Paraíba',
      PR: 'Paraná',
      PE: 'Pernambuco',
      PI: 'Piauí',
      RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte',
      RS: 'Rio Grande do Sul',
      RO: 'Rondônia',
      RR: 'Roraima',
      SC: 'Santa Catarina',
      SP: 'São Paulo',
      SE: 'Sergipe',
      TO: 'Tocantins'
    };
  }

  connectedCallback() {
    this.zipInput = this.querySelector('[data-address-zip]');
    this.row = this.querySelector('[data-shipping-row]');
    this.loadingText = this.querySelector('[data-shipping-loading]');
    this.selectedRate = this.querySelector('[data-shipping-selected-rate]');
    this.ratesSelect = this.querySelector('[data-shipping-rates-select]');
    this.errorBox = this.querySelector('[data-shipping-errors]');
    this.successBox = this.querySelector('[data-shipping-success]');
    this.clearButton = this.querySelector('[data-shipping-clear]');

    if (!this.zipInput || this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    this.zipInput.addEventListener('input', this.handleZipInput.bind(this));
    this.zipInput.addEventListener('keydown', this.handleZipKeydown.bind(this));

    if (this.ratesSelect) {
      this.ratesSelect.addEventListener('change', this.handleRateChange.bind(this));
    }

    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.clearShippingEstimate.bind(this));
    }
  }

  handleZipInput(event) {
    const formattedZip = this.formatZip(event.target.value);

    if (event.target.value !== formattedZip) {
      event.target.value = formattedZip;
    }

    const zipDigits = this.onlyDigits(formattedZip);

    clearTimeout(this.debounceTimer);

    if (zipDigits.length < 8) {
      this.resetRates();
      return;
    }

    this.debounceTimer = setTimeout(() => {
      this.calculateShipping(zipDigits);
    }, 650);
  }

  handleZipKeydown(event) {
    if (event.key !== 'Enter') return;

    event.preventDefault();

    const zipDigits = this.onlyDigits(this.zipInput.value);

    if (zipDigits.length >= 8) {
      clearTimeout(this.debounceTimer);
      this.calculateShipping(zipDigits);
    }
  }

  async calculateShipping(zipDigits) {
    if (!zipDigits || zipDigits.length < 8) return;

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    this.clearMessages();
    this.setLoading(true);

    try {
      const address = await this.getBrazilAddressByZip(zipDigits, this.abortController.signal);

      const params = new URLSearchParams();

      params.append('shipping_address[country]', 'Brazil');
      params.append('shipping_address[zip]', zipDigits);

      if (address.province) {
        params.append('shipping_address[province]', address.province);
      }

      await this.prepareShippingRates(params, this.abortController.signal);

      const rates = await this.getShippingRates(params, this.abortController.signal);

      this.renderShippingRates(rates || []);
    } catch (error) {
      if (error.name === 'AbortError') return;

      this.renderShippingError(error);
    } finally {
      this.setLoading(false);
    }
  }

  async getBrazilAddressByZip(zipDigits, signal) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${zipDigits}/json/`, {
        method: 'GET',
        signal
      });

      if (!response.ok) {
        return {
          province: ''
        };
      }

      const data = await response.json();

      if (data?.erro) {
        throw new Error('CEP inválido. Verifique e tente novamente.');
      }

      const uf = String(data.uf || '').toUpperCase();

      return {
        province: this.brazilStates[uf] || uf || ''
      };
    } catch (error) {
      if (error.name === 'AbortError') {
        throw error;
      }

      return {
        province: ''
      };
    }
  }

  async prepareShippingRates(params, signal) {
    const response = await fetch(`${this.cartPath()}/prepare_shipping_rates.json?${params.toString()}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      signal
    });

    if (!response.ok && response.status !== 202) {
      throw new Error(await this.getErrorMessage(response));
    }
  }

  async getShippingRates(params, signal) {
    const maxAttempts = 15;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const response = await fetch(`${this.cartPath()}/async_shipping_rates.json?${params.toString()}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        signal
      });

      if (response.ok) {
        const data = await response.json();

        if (Array.isArray(data.shipping_rates)) {
          return data.shipping_rates;
        }
      }

      await this.sleep(500);
    }

    throw new Error('Não foi possível calcular o frete agora. Tente novamente.');
  }

  renderShippingRates(rates) {
    if (!rates.length) {
      this.resetRates();
      this.showError('Nenhuma opção de frete encontrada para este CEP.');
      return;
    }

    const sortedRates = [...rates].sort((a, b) => this.getRatePrice(a) - this.getRatePrice(b));

    if (this.ratesSelect) {
      this.ratesSelect.innerHTML = sortedRates
        .map((rate, index) => {
          const label = this.buildRateLabel(rate);
          const price = this.formatMoney(this.getRatePrice(rate));
          const priceCents = this.getRatePriceCents(rate);

          return `<option value="${index}" data-rate-price="${price}" data-rate-cents="${priceCents}">${this.escapeHtml(label)}</option>`;
        })
        .join('');

      this.ratesSelect.hidden = false;
    }

    this.updateSelectedRate(sortedRates[0]);
    this.updateCartDrawerTotal(this.getRatePriceCents(sortedRates[0]));

    if (this.clearButton) {
      this.clearButton.hidden = false;
    }
  }

  handleRateChange(event) {
    const selectedOption = event.target.selectedOptions[0];

    if (!selectedOption || !this.selectedRate) return;

    this.selectedRate.textContent = selectedOption.dataset.ratePrice || '--';
    this.updateCartDrawerTotal(Number(selectedOption.dataset.rateCents || 0));
  }

  updateSelectedRate(rate) {
    if (!this.selectedRate || !rate) return;

    this.selectedRate.textContent = this.formatMoney(this.getRatePrice(rate));
  }

  renderShippingError(error) {
    this.resetRates();
    this.showError(error?.message || 'Não foi possível calcular o frete agora. Tente novamente.');
  }

  resetRates() {
    if (this.selectedRate) {
      this.selectedRate.textContent = '--';
    }

    if (this.ratesSelect) {
      this.ratesSelect.innerHTML = '';
      this.ratesSelect.hidden = true;
    }

    this.resetCartDrawerTotal();

    if (this.clearButton) {
      this.clearButton.hidden = true;
    }

    this.clearMessages();
  }

  clearShippingEstimate() {
    clearTimeout(this.debounceTimer);

    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }

    if (this.zipInput) {
      this.zipInput.value = '';
      this.zipInput.disabled = false;
      this.zipInput.focus();
    }

    this.setLoading(false);
    this.resetRates();
  }

  setLoading(isLoading) {
    this.classList.toggle('is-loading', isLoading);

    if (this.zipInput) {
      this.zipInput.disabled = isLoading;
    }

    if (this.loadingText) {
      this.loadingText.hidden = !isLoading;
    }

    if (this.selectedRate) {
      this.selectedRate.style.visibility = isLoading ? 'hidden' : 'visible';
    }

    if (this.clearButton && isLoading) {
      this.clearButton.hidden = true;
    }
  }

  showError(message) {
    if (!this.errorBox) return;

    this.errorBox.textContent = message;
    this.errorBox.hidden = false;
  }

  clearMessages() {
    if (this.errorBox) {
      this.errorBox.textContent = '';
      this.errorBox.hidden = true;
    }

    if (this.successBox) {
      this.successBox.textContent = '';
      this.successBox.hidden = true;
    }
  }

  async getErrorMessage(response) {
    try {
      const data = await response.json();

      if (typeof data === 'string') return data;
      if (data?.message) return data.message;
      if (data?.description) return data.description;

      if (data?.errors) {
        if (typeof data.errors === 'string') return data.errors;

        return Object.values(data.errors).flat().join(' ');
      }
    } catch (error) {
      return 'Não foi possível calcular o frete agora. Tente novamente.';
    }

    return 'Não foi possível calcular o frete agora. Tente novamente.';
  }

  buildRateLabel(rate) {
    const name = rate.name || rate.title || 'Frete';
    const price = this.formatMoney(this.getRatePrice(rate));
    const deliveryTime = this.getDeliveryTime(rate);

    return `${name} - ${price}${deliveryTime}`;
  }

  getDeliveryTime(rate) {
    const deliveryDays = rate.delivery_days;

    if (Array.isArray(deliveryDays) && deliveryDays.length) {
      const min = Math.min(...deliveryDays);
      const max = Math.max(...deliveryDays);
      const days = min === max ? `${min}` : `${min}-${max}`;

      return ` (${days} DIAS ÚTEIS)`;
    }

    if (typeof deliveryDays === 'number') {
      return ` (${deliveryDays} DIAS ÚTEIS)`;
    }

    if (rate.delivery_range) {
      return ` (${rate.delivery_range})`;
    }

    return '';
  }

  getRatePrice(rate) {
    if (!rate) return 0;

    const rawPrice = String(rate.price || rate.presentment_price || '0')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');

    const price = Number.parseFloat(rawPrice);

    return Number.isFinite(price) ? price : 0;
  }

  getRatePriceCents(rate) {
    const price = this.getRatePrice(rate);

    return Math.round(price * 100);
  }

  updateCartDrawerTotal(shippingCents) {
    const totalsWrapper = document.querySelector('[data-cart-drawer-totals]');
    const totalRow = document.querySelector('[data-cart-total-row]');
    const totalPrice = document.querySelector('[data-cart-total-price]');

    if (!totalsWrapper || !totalRow || !totalPrice) return;

    const subtotalCents = Number(totalsWrapper.dataset.cartSubtotalCents || 0);
    const finalTotalCents = subtotalCents + Number(shippingCents || 0);

    totalPrice.textContent = this.formatMoneyFromCents(finalTotalCents);
    totalRow.classList.remove('hidden');
  }

  resetCartDrawerTotal() {
    const totalsWrapper = document.querySelector('[data-cart-drawer-totals]');
    const totalRow = document.querySelector('[data-cart-total-row]');
    const totalPrice = document.querySelector('[data-cart-total-price]');

    if (!totalsWrapper || !totalRow || !totalPrice) return;

    const subtotalCents = Number(totalsWrapper.dataset.cartSubtotalCents || 0);

    totalPrice.textContent = this.formatMoneyFromCents(subtotalCents);
    totalRow.classList.add('hidden');
  }

  formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  formatMoneyFromCents(cents) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(cents || 0) / 100);
  }

  formatZip(value) {
    const digits = this.onlyDigits(value).slice(0, 8);

    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    }

    return digits;
  }

  onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  cartPath() {
    const root = window.Shopify?.routes?.root || window.routes?.root_url || '/';

    return `${root.endsWith('/') ? root : `${root}/`}cart`;
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value;

    return div.innerHTML;
  }
}

if (!customElements.get('cart-shipping-content')) {
  customElements.define('cart-shipping-content', CartShippingContent);
}